import { render, staticRenderFns } from "./gradeSet.vue?vue&type=template&id=917d22e8&scoped=true&"
import script from "./gradeSet.vue?vue&type=script&lang=js&"
export * from "./gradeSet.vue?vue&type=script&lang=js&"
import style0 from "./gradeSet.vue?vue&type=style&index=0&id=917d22e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "917d22e8",
  null
  
)

export default component.exports